export default __webpack_public_path__ + "static/gruppen-647e32d92e6308ccb45771ec8fc73314.jpg";